import { NullFunction } from '@deqo/foundation';
import React, { useState } from 'react';
import { useEffectOnce } from 'react-use';
import { LFC } from '../../Legacy';
import { ApiClient } from '../../api/ApiClient';
import { useSubmitter } from '../../platform/Hook';
import { LoadingBar } from '../../ui/LoadingBar';
import { ResultInfoForSubmitter } from '../../ui/ResultInfo';
import { useResolve } from '../Container';
import { AccountModel } from '../account/AccountModel';
import { Spacer } from '../dashboard/elements/LayoutElements';
import { Popup, PopupProps } from '../popups/Popup';
import { Button, Prompt } from './../../ui';

export const boardRestorePopup = (files: File[], toId: string) =>
    ({ ui: BoardRestorePopup, args: { files, toId } });

export const BoardRestorePopup: LFC<PopupProps> = ({ dismiss, args }) => {
    const { files, toId } = args;

    const api = useResolve(ApiClient);
    const account = useResolve(AccountModel);
    const params = `accountId=${account.id}&toId=${toId}`;

    const [count, setCount] = useState(1);
    const [progress, setProgress] = useState(0);

    const [submit, working, result] = useSubmitter(async () => {

        for (let i = 0; i < files.length; i++) {
            setCount(i + 1);
            await api.upload(`/boards.restore?${params}`, files[i], x => {
                setProgress((i + x) / files.length);
            });
        }

        return true;
    }, []);

    // const onOpen = useCallback(() => {
    //     if (result?.ok) {
    //         action(result.data);
    //     }
    // }, [result]);

    useEffectOnce(() => void (submit()));

    return <Prompt onAction={working ? NullFunction : dismiss}>
        <Popup w={32}>
            {/* <Popup.Close onAction={() => onPromptAction(false)} /> */}
            <Popup.Title>{!result ? `Restoring ${count} of ${files.length}...` : 'Restore Complete'}</Popup.Title>
            <Popup.Content>
                <LoadingBar progress={progress} />
                <Spacer f={2} />
                <ResultInfoForSubmitter result={result} />
            </Popup.Content>
            <Popup.Actions>
                {/* <Button disabled={working && !result?.ok} variant="primary" onAction={onOpen}>
                    Open Board
                </Button> */}
                <Button disabled={working} onAction={dismiss}>
                    Close
                </Button>
            </Popup.Actions>
        </Popup>
    </Prompt>;
};
